import React from "react";
import { Card, CardContent } from '@material-ui/core';
import { AccountCircle, } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import PersonIcon from "@material-ui/icons/Person";
import ArchiveIcon from "@material-ui/icons/Archive";

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

export class CoordinadorDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.styles = props.styles;
  }

  renderCoordinadorCard(user) {
    return (
      <Grid>
        <Grid container>
          <Grid item xs={12}>
            <h1><AccountCircle /> {user.nombre} ({user.dni})</h1>
            <h3>Etapa {user.etapa}</h3>
          </Grid>
        </Grid>
        <Grid container spacing={16}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <h3>Total acumulado </h3>
                <List component="nav">
                  <ListItem>
                    <ListItemText
                      primary="Mes actual"
                    />
                    <Typography variant="headline">{user.totalAcumuladoMensual} kgs.</Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary="Mes anterior"
                    />
                    <Typography variant="headline">{user.totalMesAnterior} kgs.</Typography>
                  </ListItem>

                </List>
              </CardContent>
            </Card>

          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <h3>Operaciones</h3>
                <List component="nav">
                  <ListItemLink href="#/recuperadores">
                    <ListItemIcon><PersonIcon /></ListItemIcon>
                    <ListItemText primary="Recuperadores" />
                  </ListItemLink>
                  <ListItemLink href="#/pesajes">
                    <ListItemIcon><ArchiveIcon /></ListItemIcon>
                    <ListItemText primary="Pesajes" />
                  </ListItemLink>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { user } = this.props;
    return this.renderCoordinadorCard(user);
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/Coordinador.js